import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../WebView/icons/Close.svg'


const _withScopeId = n => (_pushScopeId("data-v-44ae6586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "unread" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Your unread notices", -1))
const _hoisted_4 = {
  key: 0,
  class: "feedback-container"
}
const _hoisted_5 = { class: "feedback" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "feedback-title" }, "Your Feedback:", -1))
const _hoisted_7 = { class: "feedback-submit" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Close"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "photos" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "sender-photo" }
const _hoisted_14 = { class: "header" }
const _hoisted_15 = { class: "sender-name" }
const _hoisted_16 = { class: "meta-data" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "∙", -1))
const _hoisted_18 = { class: "time" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "∙", -1))
const _hoisted_20 = { class: "sent-to" }
const _hoisted_21 = {
  key: 0,
  class: "options"
}
const _hoisted_22 = ["data-action", "onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-action": "feedback" }, "+ Add Feedback", -1))
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!
  const _component_NoticeTypeBadge = _resolveComponent("NoticeTypeBadge")!
  const _component_Quote = _resolveComponent("Quote")!
  const _component_TextWithHighlight = _resolveComponent("TextWithHighlight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, _toDisplayString(_ctx.remainingNoticesCount) + " left", 1)
    ], 512), [
      [_vShow, _ctx.remainingNoticesCount]
    ]),
    (_ctx.writingFeedback)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "close",
              "data-action": "feedback",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.writingFeedback = false))
            }, " × "),
            _hoisted_6,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.feedbackComment) = $event)),
                placeholder: "Write Feedback",
                rows: "5"
              }, null, 512), [
                [_vModelText, _ctx.feedbackComment]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_BaseButton, {
                disabled: _ctx.feedbackComment.length < 1,
                click: _ctx.onSubmitFeedback,
                class: "btn-submit",
                primary: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Submit")
                ], undefined, true),
                _: 1
              }, 8, ["disabled", "click"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "close",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.respond('close')))
      }, _hoisted_10),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["notice-photo", _ctx.noticeClassName])
        }, [
          _createElementVNode("img", {
            src: _ctx.noticeType.icon
          }, null, 8, _hoisted_12)
        ], 2),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_AvatarOrInitials, {
            user: _ctx.notice.sender,
            size: 30
          }, null, 8, ["user"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.notice.sender.name), 1),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_NoticeTypeBadge, {
            class: "notice-type",
            "notice-type": _ctx.notice.type
          }, null, 8, ["notice-type"]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.timeSinceNoticeCreated(_ctx.notice.created)), 1),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.sentTo), 1)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["body", { 'is-receiver': _ctx.isReceiver && _ctx.notice.seen }])
      }, [
        (_ctx.notice.questioncomment)
          ? (_openBlock(), _createBlock(_component_Quote, {
              key: 0,
              class: "quote-comment",
              text: _ctx.notice.questioncomment
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "comment",
          style: _normalizeStyle('font-size: ' + _ctx.commentFontSize + 'px')
        }, [
          _createVNode(_component_TextWithHighlight, {
            class: "subject",
            text: _ctx.notice.message,
            highlights: _ctx.highlights
          }, null, 8, ["text", "highlights"])
        ], 4)
      ], 2)
    ]),
    (_ctx.isReceiver && !_ctx.notice.seen)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.allowedRespondAction)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AVAILABLE_NOTICE_REACTION_TYPES, (emoji, reactionKey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: reactionKey,
                    class: "respond",
                    "data-action": reactionKey,
                    onClick: ($event: any) => (_ctx.respond(reactionKey))
                  }, _toDisplayString(emoji), 9, _hoisted_22))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle({
                    visibility: _ctx.showAddFeedback ? 'visible' : 'hidden',
                }),
            class: "respond-feedback",
            "data-action": "feedback",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.writingFeedback = true))
          }, _hoisted_24, 4)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}